import axios from "@/axios.js";
import Api from "@/helpers/api";

export default {
  setTodoSearchQuery({ commit }, query) {
    commit("SET_TODO_SEARCH_QUERY", query);
  },
  async fetchTasks({ commit }, payload) {
    try {
      const data = {
        companyID: payload,
        table: "Forms",
        fields: ["activity", "formType", "formID", "created_at", "groupName", "status"],
        limit: 200
      };
      const result = await Api.post("/fql", data);
      commit("SET_TASKS", result.data);
      return result.data;
    } catch (error) {
      commit("SET_TASKS", []);
      throw error;
    }
  },
  fetchTasks2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/apps/todo/tasks", { params: { filter: payload.filter } })
        .then(response => {
          commit("SET_TASKS", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchTags({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/apps/todo/tags")
        .then(response => {
          commit("SET_TAGS", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  addTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/apps/todo/tasks/", { task })
        .then(response => {
          commit("ADD_TASK", Object.assign(task, { id: response.data.id }));
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/apps/todo/task/${task.id}`, { task })
        .then(response => {
          commit("UPDATE_TASK", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
